import callApi from '../../util/apiCaller';

export function loadContact(contactId) {
  const p = new Promise((resolve, reject) => {
    callApi(`contacts/${contactId}`, 'GET').then(
      (results) => {
        resolve(results);
      },
      (error) => {
        reject(error);
      },
    );
  });
  return p;
}